module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA20lEQVR42p2TwQqCQBRF+6n+plWLtn1ACz+qH4jARSFEIIaSIFlSTbgTFcyXd+DBpA2venB4c2HuYRAcEZHGcRz6gkXHCHDvTVDXNZVlOaCqKlMytwowURQN6AZF3s+OqVWQJEkfLpqUVoFSikI/0psxh2VWwfEQ02Q8o83KozzP+8iCoiho5+615BSnyCayAF/8nGQQYCMDPsuCpmnomt60wN8GZsaWBTzrpatLKnsg8pYFfBnlwAsR/xZwCSLOoqBf6L9GEAjPFwX4mdq2pftFYX8Cd+yCX+DeC5A+MoQOrK9aAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/text-x-script.png
// module id = PSqp
// module chunks = 1